import styled from 'styled-components'

export const Label = styled.label`
  font-weight: 500;
  margin-bottom: ${(p) => {
    return p.marginBottomLabel ? p.marginBottomLabel : '16px'
  }};  
  font-size: 14px;
  line-height: 24px;
  color: #202020;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    cursor: pointer;
  }

  svg {
    margin: 0 8px;
  }

  span {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color:rgba(32, 32, 32, 0.5);
  }
`

export const Error = styled.div`
  color: #E11900;
  font-size: 14px;
  margin-top: ${(p) => {
    return p.errorMarginTop
  }};
  line-height: 20px;
`

export const InputFieldErrorIcon = styled.img`
  margin-top: 20px;
  margin-left: -60px;
  position: absolute;
`

export const SelectContainer = styled.div`
  margin-bottom: ${(p) => {
    return p.marginBottom
  }};
  font-size: 14px;  
`

export const SearchSelectIconContainer = styled.div`
  position: relative;
`

export const SearchSelectIconWrapper = styled.div`
  position: absolute;  
  top: 12px;
  left: 8px;
  margin-right: 20px;
  z-index: 1;
`
